
import React from "react";
import {router, usePage} from "@inertiajs/react";
import {useLaravelReactI18n} from "laravel-react-i18n";
import InertiaTable from "laravel-inertia-react-table";
import {mdiPlus} from "@mdi/js";
import Icon from "@mdi/react";
import {Button} from "react-bootstrap";

export default function Transactions(props) {
    const { t } = useLaravelReactI18n();
    const { transactions,auth } = usePage().props;

  const handleAddClick = () => {
    router.get('transactions/create');
  }

  const customToolbarButtons = (<Button variant="secondary" onClick={handleAddClick}><Icon path={mdiPlus} size={1}/></Button>);

  const handleRowClick = (transaction) => {
    router.get('transactions/'+transaction.id+'/edit');
  }

  return (<InertiaTable data={ transactions } customToolbarButtons={customToolbarButtons} onRowClick={auth.group_id===1 ? handleRowClick : null}/>);
}



